<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Refresh Planogram</h4>
  <button
    type="button"
    class="btn btn-link p-0 border-0"
    aria-label="Close"
    (click)="cancel()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body p-3">
  <!-- Summary -->
  <div class="alert alert-info mb-3">
    <div class="d-flex justify-content-between">
      <span>Current products in range:</span>
      <strong>{{ currentProductCount }}</strong>
    </div>
    <div class="d-flex justify-content-between mt-1">
      <span>Products to add:</span>
      <strong class="text-success">{{ addBarcodes.length }}</strong>
    </div>
    <div class="d-flex justify-content-between mt-1">
      <span>Products to remove:</span>
      <strong class="text-danger">{{ removeBarcodes.length }}</strong>
    </div>
  </div>

  <!-- State Name -->
  <div class="mb-3">
    <label for="stateName" class="form-label">New State Name (optional)</label>
    <input
      type="text"
      class="form-control"
      id="stateName"
      [(ngModel)]="stateName"
      placeholder="Enter a name for the new state" />
  </div>

  <!-- Sales Period -->
  <div class="card mb-3">
    <div class="card-header bg-light">
      <h6 class="m-0">Sales Period</h6>
    </div>
    <div class="card-body">
      <div class="row g-3">
        <div class="col-6">
          <label for="salesStart" class="form-label">Start Month</label>
          <input
            type="month"
            class="form-control"
            id="salesStart"
            [(ngModel)]="salesPeriodStartMonth" />
        </div>
        <div class="col-6">
          <label for="salesEnd" class="form-label">End Month</label>
          <input
            type="month"
            class="form-control"
            id="salesEnd"
            [(ngModel)]="salesPeriodEndMonth" />
        </div>
      </div>
      <small class="text-muted">
        Sales data will be fetched for the selected period to update product metrics.
      </small>
    </div>
  </div>

  <!-- Add Products -->
  <div class="card mb-3">
    <div class="card-header bg-light">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="m-0">
          <i class="bi bi-plus-circle text-success me-2"></i>Add Products to Range
        </h6>
        <span class="badge bg-success">{{ addBarcodes.length }}</span>
      </div>
    </div>
    <div class="card-body">
      <!-- Add barcode form -->
      <form (ngSubmit)="addToAddList()" class="mb-2">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newAddBarcode"
            name="addBarcode"
            placeholder="Enter barcode to add" />
          <button
            class="btn btn-success"
            type="submit"
            [disabled]="!newAddBarcode.trim()">
            <i class="bi bi-plus"></i> Add
          </button>
        </div>
      </form>

      <!-- Add barcodes list -->
      <div class="barcode-list row g-2">
        @for (barcode of addBarcodes; track barcode) {
          <div class="col-auto">
            <div class="badge d-flex gap-2 align-items-center border border-success bg-white text-success p-2">
              <span>{{ barcode }}</span>
              <button
                class="btn btn-sm btn-outline-success"
                (click)="removeFromAddList(barcode)">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>
        }

        @if (addBarcodes.length === 0) {
          <div class="text-muted text-center py-2">
            No products selected to add
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Remove Products -->
  <div class="card">
    <div class="card-header bg-light">
      <div class="d-flex justify-content-between align-items-center">
        <h6 class="m-0">
          <i class="bi bi-dash-circle text-danger me-2"></i>Remove Products from Range
        </h6>
        <span class="badge bg-danger">{{ removeBarcodes.length }}</span>
      </div>
    </div>
    <div class="card-body">
      <!-- Remove barcode form -->
      <form (ngSubmit)="addToRemoveList()" class="mb-2">
        <div class="input-group">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="newRemoveBarcode"
            name="removeBarcode"
            placeholder="Enter barcode to remove" />
          <button
            class="btn btn-danger"
            type="submit"
            [disabled]="!newRemoveBarcode.trim()">
            <i class="bi bi-dash"></i> Add
          </button>
        </div>
      </form>

      <!-- Remove barcodes list -->
      <div class="barcode-list row g-2">
        @for (barcode of removeBarcodes; track barcode) {
          <div class="col-auto">
            <div class="badge d-flex gap-2 align-items-center border border-danger bg-white text-danger p-2"
                 [class.bg-warning]="isOnLayout(barcode)">
              <span>
                {{ barcode }}
                @if (isOnLayout(barcode)) {
                  <i class="bi bi-exclamation-triangle ms-1" title="Product is placed on layout"></i>
                }
              </span>
              <button
                class="btn btn-sm btn-outline-danger"
                (click)="removeFromRemoveList(barcode)">
                <i class="bi bi-x"></i>
              </button>
            </div>
          </div>
        }

        @if (removeBarcodes.length === 0) {
          <div class="text-muted text-center py-2">
            No products selected to remove
          </div>
        }
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="cancel()" [disabled]="isRefreshing">
    Cancel
  </button>
  <button type="button"
      class="btn btn-primary"
      (click)="confirm()"
      [disabled]="isRefreshing || !isValid()">
    @if (isRefreshing) {
      <span class="spinner-border spinner-border-sm me-2"></span>
      Refreshing...
    } @else {
      Refresh Planogram
    }
  </button>
</div>